import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Input, Table, Modal, Popup, Icon} from 'semantic-ui-react';
import {tabKeyCode, enterKeyCode} from '../../../../common/constants/keyCodes';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {stopEvent} from '../../../../common/util/event';
import {Actions} from '../../../../common/actions';

class OrderDetail extends Component {
  handlePartCodeChange(index, event, data) {
    this.props.updateItemValueFromInternalOrder(index, data);
  }

  handlePartCodeKeyDown(index, event) {
    const {value} = event.target;
    const {keyCode} = event;
    if ([tabKeyCode, enterKeyCode].includes(keyCode)) {
      const {warehouse} = this.props;
      const targetField = document.getElementById(`quantity${index}`);

      if (!value) {
        this.props.addMessageBoxError('Código de repuesto no válidos');
        return;
      }

      this.props.verifyStockInWarehouse(warehouse, value, index);
      stopEvent(event);
      setTimeout(() => targetField.focus(), 1000);
    }
  }

  handleQuantityChange({index, price = 0}, event, data) {
    const {value} = data;
    this.props.updateItemValueFromInternalOrder(index, data);
    this.props.updateSubtotal(index, value, price);
  }

  handleQuantityKeyDown(index, element, event) {
    const {keyCode} = event;
    if ([tabKeyCode, enterKeyCode].includes(keyCode)) {
      const {orderCode} = this.props;
      const hasValidQuantity = this.validateQuantity(element.quantity || 0, element.availableStock);

      if (!hasValidQuantity) {
        return;
      }

      const data = {
        'partCode': element.partCode,
        'quantity': element.quantity,
        'price': parseFloat(element.price),
      };

      this.props.addItemToInternalOrder(index, orderCode, data);
      stopEvent(event);
    }
  }

  getTotalValue(list, field) {
    let total = 0;
    list.forEach((element) => {
      const value = parseFloat(element[field]) || 0;
      total += value;
    });
    return total.toFixed(2);
  }
  
  validateQuantity(quantity, availableStock) {
    if (!quantity || quantity < 0) {
      this.props.addMessageBoxError('Debe ingresar un valor entero en el campo Cantidad');
      return false;
    }
  
    if (!Number.isInteger(quantity)) {
      this.props.addMessageBoxError('Verifique el valor ingresado, no puede ser número decimal');
      return false;
    }
  
    if (quantity.toString().length > 10) {
      this.props.addMessageBoxError('La longitud del valor ingresado no puede ser mayor a 10 digitos');
      return false;
    }
  
    const quantityMaxAllowed = parseInt(availableStock, 10);
    if (quantity === 0 || quantity > quantityMaxAllowed) {
      this.props.addMessageBoxError(
        `Verifique el valor ingresado, no puede ser 0 ni mayor a ${quantityMaxAllowed}`
      );
      return false;
    }
  
    return true;
  }

  handleDeleteItem(index, partCode) {
    const {orderCode} = this.props;
    const data = {'partCode': partCode};
    this.props.deleteItemFromInternalOrder(index, orderCode, data);
  }

  renderElements() {
    const {elements, savingLineInfo} = this.props;
    
    return elements.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            {this.renderPartCode(index, element, savingLineInfo)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderPartQuantity(index, element, savingLineInfo)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.availableStock}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{element.price || 0}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{element.subTotal || 0}</Table.Cell>
          {this.renderDeleteColumn(index, element.itemSaved, element.partCode)}
        </Table.Row>
      );
    });
  }

  renderPartCode(index, element, savingStatus) {
    if (element.itemSaved) {
      return element.partCode;
    }

    return (
      <Input autoFocus
        name='partCode'
        value={element.partCode}
        onChange={(event, data) => this.handlePartCodeChange(index, event, data)}
        onKeyDown={(event) => this.handlePartCodeKeyDown(index, event)}
        disabled={savingStatus}
      />
    );
  }

  renderPartQuantity(index, element, savingStatus) {
    if (element.itemSaved) {
      return element.quantity;
    }

    const isDisabled = !element.partChecked || savingStatus;

    return (
      <Input
        id={`quantity${index}`}
        name='quantity'
        value={element.quantity}
        onChange={(event, data) => this.handleQuantityChange({index, 'price': element.price}, event, data)}
        onKeyDown={(event) => this.handleQuantityKeyDown(index, element, event)}
        disabled={isDisabled}
      />
    );
  }

  renderDeleteColumn(index, itemSaved, partCode) {
    if (!hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Delete)) {
      return null;
    }

    return (
      <Table.Cell textAlign='center'>
        {this.renderDeleteButton(index, itemSaved, partCode)}
      </Table.Cell>
    );
  }

  renderDeleteButton(index, itemSaved, partCode) {
    if (!itemSaved) {
      return null;
    }

    return (
      <Modal size='mini'
        trigger={
          <span className='link'>
            <Popup
              trigger={
                <span>
                  <Icon link name='delete' color='blue' size='large' />
                </span>
              }
              content="Eliminar"
              position='top center'
              inverted
            />
          </span>
        }
        header='¿Está seguro que desea eliminar el item seleccionado?'
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar', 'positive': true,
            'onClick': () => this.handleDeleteItem(index, partCode),
            'primary': true,
          },
        ]}
      />
    );
  }

  renderActionsColumnInTotalsRow() {
    if (!hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Delete)) {
      return null;
    }
    return <Table.Cell textAlign='center' />;
  }

  renderTotalValues() {
    const {elements} = this.props;

    const subTotal = this.getTotalValue(elements, 'subTotal');
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left' colSpan={2}>
          <span>TOTAL</span>
        </Table.Cell>
        <Table.Cell textAlign='center'>
          <span>{_.sumBy(elements, 'quantity')}</span>
        </Table.Cell>
        <Table.Cell textAlign='center'>
        </Table.Cell>
        <Table.Cell textAlign='right'>
        </Table.Cell>
        <Table.Cell textAlign='right'>
          <span className='totals-row'>{'$'}{getNumericValue(subTotal, 2)}</span>
        </Table.Cell>
        {this.renderActionsColumnInTotalsRow()}
      </Table.Row>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderElements()}
        {this.renderTotalValues()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const internalOrderToEdit = state.internalOrder.internalOrderToEdit;

  return {
    'permissions': state.session.permissions,
    'elements': state.internalOrderForm.elements,
    'orderCode': internalOrderToEdit ? internalOrderToEdit.code : '',
    'clientRuc': internalOrderToEdit ? internalOrderToEdit.clientRuc : '',
    'warehouse': internalOrderToEdit ? internalOrderToEdit.warehouse : '',
    'savingLineInfo': state.internalOrder.creating,
  };
};

const {
  navigateTo,
  verifyStockInWarehouse,
  updateItemValueFromInternalOrder,
  updateSubtotal,
  addItemToInternalOrder,
  deleteItemFromInternalOrder,
  addMessageBoxError,
} = Actions;

export default connect(mapStateToProps, {
  verifyStockInWarehouse,
  updateItemValueFromInternalOrder,
  updateSubtotal,
  addItemToInternalOrder,
  deleteItemFromInternalOrder,
  addMessageBoxError,
  navigateTo,
})(OrderDetail);
